<template lang="pug">
.reservation-register(v-cloak)
  .register-body.mt-4
    .note
      span.note-title ※代理予約は以下の点に注意してご使用ください
      b-card-text 
        ul.confirm-list
          li HitomeQ コネクト未登録ご家族の予約の場合、案内の自動配信はありません。
          li オンライン面会予約の場合、ご家族の面会場所（ご自宅もしくは施設訪問）をご確認ください。
          li ご家族が施設に訪問してオンライン面会する場合、施設内の面会場所と機材をご準備ください。
    FormInputSelect(
      key-name="利用者グループ"
      name="resident-group"
      v-model="residentGroupId"
      :options="residentGroupOptions"
      :styles="{ 'max-width': '540px' }")
    .d-flex.flex-row
      FormInputSelect(
        key-name="利用者"
        required
        name="resident"
        v-model="residentId"
        :options="_residentOptions"
        :validation-rules="{ required: true }"
        :styles="{ 'max-width': '340px' }"
        style="max-width: 360px")
        template(#optionText)
          .list-sort.d-flex.flex-row.align-items-center.mt-2(v-if="0 < _residentOptions.length" style="width: 100%;")
            span(style="font-weight: normal; font-size: 14px; min-width: 60px;") 並び順：
            b-form-select(v-model="residentSortCondition" :options="_residentSortOptions" size="sm")
      .mr-3
      .search-filter.d-flex.flex-column.align-self-end.mb-3
        .d-flex.flex-row.align-items-center(style="margin-top: 35px;")
          b-input-group.search-filter-input-group.mr-1(size="md")
            b-input-group-prepend
              b-input-group-text.search-filter-icon
                .search-icon
            b-form-input.search-filter-input(v-model="residentSearchWord" type="search" placeholder="検索ワードを入力してください" @input="changeResidentSearchWord"
              style="height: 42px;")
          HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="search-filter-help" title="検索項目について")
            template(v-slot:text)
              div 検索項目は以下になります。
              div ・利用者名
              div ・利用者名（ふりがな）
              div ・部屋名
    FormInputReservationUseFamily(v-model="useFamily" :showRegisterd="showFamilyRegisterd")
    FormInput(
      v-if="useFamily == false"
      key-name="面会者名（家族名）"
      required
      name="family-name"
      v-model="familyName"
      type="text"
      placeholder="面会者名（家族名）"
      :maxlength="32"
      :validation-rules="{ required: true, max: 32 }"
      :styles="{ width: '340px' }")
    FormInput(
      v-if="useFamily == false"
      key-name="続柄"
      name="family-relation"
      v-model="familyRelation"
      type="text"
      placeholder="続柄"
      :maxlength="10"
      :validation-rules="{ max: 10 }"
      :styles="{ width: '340px' }")
    FormInput(
      v-if="useFamily == false"
      key-name="電話番号"
      required
      name="family-tel"
      v-model="familyTel"
      type="text"
      placeholder="電話番号"
      :maxlength="13"
      :validation-rules="{ required: true, tel: true, max: 13 }"
      :styles="{ width: '340px' }")
    FormInputSelect(
      v-if="useFamily == true"
      key-name="面会者（家族）の選択"
      required
      name="family"
      v-model="familyId"
      :options="familyOptions"
      :validation-rules="{ required: true }"
      :styles="{ 'max-width': '540px' }")
    FormInputReservationType(v-model="type")
    FormInputSplitDateTime(
      key-name="面会日時"
      required
      :showYear="showYear"
      :year.sync="year"
      :years="years"
      :month.sync="month"
      :months="months"
      :day.sync="day"
      :days="days"
      :hour.sync="hour"
      :hours="hours"
      :min.sync="min"
      :mins="mins"
      :realtimeError="reservationDateErrorMessage"
      validationDateKeyName="面会日時")
    FormInputSelect(
      v-if="useLocation && type == 0"
      key-name="面会場所"
      required
      name="location"
      v-model="location"
      :options="locationOptions"
      :validation-rules="{ required: true }"
      :styles="{ 'max-width': '340px' }")
    //- 同一利用者の家族に共有するか否か
    FormInputRadio(v-model="isSharedReservation" name="is-shared-reservation" key-name="予約を他の同一利用者家族にも共有する"
      :options="_isSharedReservationOptions" :validation-rules="{ required: true }" required)
    FormTextarea(
      v-if="_showText"
      v-model="text" name="text" key-name="家族からの連絡事項" placeholder="家族からの連絡事項をご記載ください。"
      :validation-rules="{ max: 1000 }" :maxlength="1000" :styles="{ maxWidth: '600px', width: '600px', minHeight: '160px' }")

    .register-row(v-show="errorMessage")
      .register-group
        .register-value
          .error-message {{ errorMessage }}

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")
    .buttons.m-0
      button.btn.register-btn(@click="showConfirmModal" type="button") 登録
      button.btn.cancel-btn(@click="gotoReservationList" type="button") キャンセル

  OkCancelModal(v-model="showRegisterModal" title="面会予約情報を登録しますか？" @ok="registerReservation")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoReservationList")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";

import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import ResidentsService, { ResidentGetModel } from "@/commons/services/Residents";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import ReservationSettingsService, { ReservationInputType, ReservationSettingsGetModel, GroupUseType } from "@/commons/services/ReservationSettings";
import OnlineReservationSettingsService, { OnlineReservationSettingsGetModel } from "@/commons/services/OnlineReservationSettings";
import ReservableSchedulesService, { ReservableSchedulesGetModel } from "@/commons/services/ReservableSchedules";
import ReservableOnlineSchedulesService, { ReservableOnlineSchedulesGetModel } from "@/commons/services/ReservableOnlineSchedules";
import ReservationsService, { ReservationsPostModel, InputType } from "@/commons/services/Reservations";
import OnlineReservationsService, { OnlineReservationPostModel } from "@/commons/services/OnlineReservations";
import SystemError from "@/commons/models/SystemError";
import FamiliesService, { FamilyGetModel, SenderType } from "@/commons/services/Families";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormInputReservationType from "@/pc/components/reservations/FormInputReservationType.vue";
import FormInputReservationUseFamily from "@/pc/components/reservations/FormInputReservationUseFamily.vue";
import FormInputSplitDateTime from "@/pc/components/forms/FormInputSplitDateTime.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * ### 代理予約タブコンポーネント
 */
@Component({
  components: {
    OkCancelModal,
    OkModal,
    PageLoading,
    ValidationAlert,
    FormInput,
    FormInputRadio,
    FormInputSelect,
    FormInputReservationType,
    FormInputReservationUseFamily,
    FormInputSplitDateTime,
    FormTextarea,
    HelpIcon
  },
  /**
   * #Topic:
   * バリデーターを使いたいコンポーネントは以下を記載してバリデーターをnewする
   */
  $_veeValidate: { validator: "new" }
})
export default class ReservationRegisterTab extends Vue {
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 家族ユーザーサービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 訪問面会設定サービス */
  @Inject("ReservationSettingsService") reservationSettingsService!: ReservationSettingsService;
  /** オンライン面会設定サービス */
  @Inject("OnlineReservationSettingsService") onlineReservationSettingsService!: OnlineReservationSettingsService;
  /** 訪問面会スケジュールサービス(予約可能) */
  @Inject("ReservableSchedulesService") reservableSchedulesService!: ReservableSchedulesService;
  /** オンライン面会スケジュールサービス(予約可能) */
  @Inject("ReservableOnlineSchedulesService") reservableOnlineSchedulesService!: ReservableOnlineSchedulesService;
  /** 訪問面会サービス */
  @Inject("ReservationsService") reservationsService!: ReservationsService;
  /** オンライン面会サービス */
  @Inject("OnlineReservationsService") onlineReservationsService!: OnlineReservationsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 利用者グループID */
  residentGroupId: number = 0;
  /** 利用者グループセレクトボックス用項目 */
  residentGroupOptions: Array<{ value: number | string; label: string }> = [];
  /** セレクトボックス用項目で使用する利用者 */
  residents: Array<ResidentGetModel> = [];
  /** 利用者ID */
  residentId: any | number = "";
  /** 利用者セレクトボックス用項目 */
  residentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = [];
  /** 初期取得時の利用者セレクトボックス用項目 */
  sourceResidentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = [];
  /** 利用者ソート条件 */
  residentSortCondition: ResidentSortCondition = ResidentSortCondition.NONE;
  /** 利用者検索ワード */
  residentSearchWord: string = "";
  /** 登録種別 */
  useFamily: boolean = false;
  /** 家族の登録済みを表示するか否か */
  showFamilyRegisterd: boolean = true;
  /** 家族ID */
  familyId: any | number = "";
  /** 家族ユーザーセレクトボックス用項目 */
  familyOptions: Array<{ value: number | string; label: string }> = [];
  /** 家族名 */
  familyName: string = "";
  /** 家族続柄 */
  familyRelation: string = "";
  /** 家族電話番号 */
  familyTel: string = "";
  /** 面会種別 */
  type: number = 0;
  /** 連絡事項 */
  text: string = "";

  /** 面会場所の使用可否 */
  useLocation: boolean = false;
  /** 面会場所 */
  location: string = "";
  /** 面会場所セレクトボックス用項目 */
  locationOptions: Array<{ value: number | string; label: string }> = [];

  /** 訪問面会設定 */
  setting!: ReservationSettingsGetModel;
  /** オンライン面会設定 */
  onlineSetting!: OnlineReservationSettingsGetModel;
  /** 利用者の所属するグループID */
  groupId: number = 0;
  /** 利用者名 */
  residentName: string = "";
  /** 利用者部屋名 */
  residentRoom: string = "";

  /** 年の入力可否 */
  showYear: boolean = false;
  /** 年 */
  year: string = "";
  /** 年選択項目 */
  years: Array<{ label: string; value: number }> = [];
  /** 月 */
  month: string = "";
  /** 月選択項目 */
  months: Array<string> = [];
  /** 日 */
  day: string = "";
  /** 日選択項目 */
  days: Array<string> = [];
  /** 時 */
  hour: string = "";
  /** 時選択項目 */
  hours: Array<string> = [];
  /** 分 */
  min: string = "";
  /** 分選択項目 */
  mins: Array<string> = [];
  /** 選択項目を作成するための予約可能な訪問面会スケジュール。「月」を選択したタイミングで取得する */
  reservationSchedules: Array<ReservableSchedulesGetModel> = [];
  /** 選択項目を作成するための予約可能なオンライン面会スケジュール。「月」を選択したタイミングで取得する */
  onlineReservationSchedules: Array<ReservableOnlineSchedulesGetModel> = [];
  /** 同一利用者の家族に共有するか否か。v3.38.0以前はundefined */
  isSharedReservation: boolean = false;

  /** エラーメッセージ */
  errorMessage: string = "";
  /** 面会日時エラーメッセージ */
  reservationDateErrorMessage: string = "";

  get _showText(): boolean {
    // 面会種別が未選択の場合は強制非表示
    if (this.type == null) {
      return false;
    }
    // 現在訪問か、オンラインかで見る設定が異なる
    if (this.type == 0) {
      return this.setting && this.setting.useText ? true : false;
    } else {
      return this.onlineSetting && this.onlineSetting.useText ? true : false;
    }
  }

  /** 同一利用者の家族に共有するか否か。v3.38.0以前はundefined */
  get _isSharedReservationOptions(): Array<{ value: boolean; label: string }> {
    return [
      { value: true, label: "はい" },
      { value: false, label: "いいえ" }
    ];
  }

  /**
   * ### 利用者グループIDの値更新を監視する
   *
   * - 利用者IDをリセットする
   * - 利用者のセレクトボックス選択項目を更新する
   */
  @Watch("residentGroupId")
  public async changeResidentGroupId(newValue: number): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const residentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = this.createResidentOptions(this.residents, newValue);
    this.residentId = "";
    this.sourceResidentOptions = residentOptions;
    this.changeResidentSearchWord();
    this.showYear = false;
    this.location = "";

    this.isBusy = false;

    return;
  }

  /**
   * ### 利用者IDの値更新を監視する
   *
   * - 登録済み家族かをリセットする
   * - 面会種別をリセットする
   *   - 機能制限で訪問面会が使用できない場合はオンライン面会固定とする
   * - 面会者名、続柄、電話番号をリセットする
   * - 面会日時をリセットする
   * - 面会日時のエラーメッセージをリセットする
   * - 利用者IDが空文字なら処理終了
   * - 利用者が変更されたので保持するグループIDを取得する
   * - 登録種別が「登録済の家族」であれば家族ユーザーの選択肢を更新する
   */
  @Watch("residentId")
  public async changeResidentId(newValue: any | number): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      if (newValue) {
        this.showYear = true;
      } else {
        this.showYear = false;
      }

      this.useFamily = false;
      if (userStore.facility.permittedFunctions.reservation == true) {
        this.type = 0;
      } else {
        this.type = 1;
      }
      this.familyName = "";
      this.familyRelation = "";
      this.familyTel = "";
      this.year = "";
      this.month = "";
      this.day = "";
      this.hour = "";
      this.min = "";

      this.location = "";
      this.reservationDateErrorMessage = "";

      if (!newValue) {
        return;
      }

      const resident: ResidentGetModel = await this.getResident(newValue);
      this.residentName = resident.name;
      this.residentRoom = resident.room;
      const groupId: number = this.getGroupId(resident);
      this.groupId = groupId;

      const families: Array<FamilyGetModel> = await this.getFamilies(newValue);
      const familyOptions: Array<{ value: number | string; label: string }> = this.createFamilyOptions(families);
      this.familyId = "";
      this.familyOptions = familyOptions;

      if (familyOptions.length < 1) {
        this.showFamilyRegisterd = false;
      } else {
        this.showFamilyRegisterd = true;
      }
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 面会種別の値更新を監視する
   *
   * - 面会日時をリセットする
   * - 面会日時のエラーメッセージをリセットする
   */
  @Watch("type")
  public async changeType(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.year = "";
      this.month = "";
      this.day = "";
      this.hour = "";
      this.min = "";

      this.location = "";
      this.reservationDateErrorMessage = "";

      const resident: ResidentGetModel = await this.getResident(this.residentId);
      const groupId: number = this.getGroupId(resident);
      this.groupId = groupId;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 年の値更新を監視する
   *
   * - 月以降の入力値をリセットする
   * - 面会日時のエラーメッセージをリセットする
   * - 月のセレクトボックスの選択肢を更新する
   */
  @Watch("year")
  public changeYear(newValue: string): void {
    this.month = "";
    this.day = "";
    this.hour = "";
    this.min = "";

    this.reservationDateErrorMessage = "";

    const months: Array<string> = this.createMonths(Number(newValue));
    this.months = months;

    return;
  }

  /**
   * ### 月の値更新を監視する
   *
   * - 日以降の入力値をリセットする
   * - 面会日時のエラーメッセージをリセットする
   * - 値がリセットされた場合は処理をしない
   * - 日のセレクトボックスの選択肢を更新する
   */
  @Watch("month")
  public async changeMonth(newValue: string): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.day = "";
      this.hour = "";
      this.min = "";

      this.reservationDateErrorMessage = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const days: Array<string> = await this.createDays(this.groupId, Number(this.year), Number(newValue));
      this.days = days;

      if (days.length == 0) {
        this.reservationDateErrorMessage = "選択月の面会日時設定が登録されていないか、利用者ごとの面会制限に達しています";
      } else {
        this.reservationDateErrorMessage = "";
      }
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 日の値更新を監視する
   *
   * - 時以降の入力値をリセットする
   * - 値がリセットされた場合は処理をしない
   * - 時のセレクトボックスの選択肢を更新する
   */
  @Watch("day")
  public async changeDay(newValue: string): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.hour = "";
      this.min = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const hours: Array<string> = this.createHours(Number(newValue));
      this.hours = hours;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 時の値更新を監視する
   *
   * - 分以降の入力値をリセットする
   * - 値がリセットされた場合は処理をしない
   * - 分のセレクトボックスの選択肢を更新する
   */
  @Watch("hour")
  public async changeHour(newValue: string): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    try {
      this.min = "";

      if (!newValue) {
        this.isBusy = false;
        return;
      }

      const mins: Array<string> = this.createMins(Number(this.day), Number(newValue));
      this.mins = mins;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 利用者ソート条件の値更新を監視する
   */
  @Watch("residentSortCondition")
  public changeResidentSortCondition(): void {
    this.sourceResidentOptions = this.createResidentOptions(this.residents, this.residentGroupId);
    this.changeResidentSearchWord();
  }

  get _residentSortOptions(): Array<{ value: ResidentSortCondition; text: string }> {
    return [
      { value: ResidentSortCondition.ROOM_NAME_ASC, text: "部屋名順" },
      { value: ResidentSortCondition.NAME_ASC, text: "利用者名順" }
    ];
  }

  get _residentOptions() {
    return this.residentOptions;
  }

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   *
   * - 機能の使用許可に応じて面会種別の初期値を決める
   * - セレクトボックス用の利用者グループリストを作成する
   * - セレクトボックスの利用者グループ初期値は0(全て)とする
   * - セレクトボックス用の利用者リストを作成する
   * - 訪問面会の設定を取得する
   * - オンライン面会の設定を取得する
   * - 利用者グループ入力を使用するかを取得する
   * - セレクトボックス用の年月日日時分のリストを作成する
   */
  public async createView(): Promise<void> {
    this.errorMessage = "";

    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    if (userStore.facility.permittedFunctions.reservation == true) {
      this.type = 0;
    } else {
      this.type = 1;
    }

    const residents: Array<ResidentGetModel> = await this.getResidents();
    const residentOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = this.createResidentOptions(residents, this.residentGroupId);
    this.residents = residents;
    this.residentOptions = residentOptions;
    this.sourceResidentOptions = this.createResidentOptions(residents, this.residentGroupId);

    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const residentGroupOptions: Array<{ value: number; label: string }> = this.createResidentGroupOptions(residentGroups, residents);
    this.residentGroupId = 0;
    this.residentGroupOptions = residentGroupOptions;

    const setting: ReservationSettingsGetModel = await this.getReservationSetting();
    this.setting = setting;

    // 面会場所についての情報を作成
    this.useLocation = setting.useLocation;
    if (setting.useLocation) {
      const options: Array<{ value: number | string; label: string }> = [];
      for (const option of this.setting.locationOptions) {
        options.push({
          label: option.name,
          value: option.name
        });
      }
      this.locationOptions = options;
    }

    const onlineSetting: OnlineReservationSettingsGetModel = await this.getOnlineReservationSetting();
    this.onlineSetting = onlineSetting;

    this.years = this.createYears();

    this.isBusy = false;

    return;
  }

  /**
   * ### 利用者グループ取得
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループセレクトボックス用項目を作成する
   *
   * - 利用者グループに「全て」を追加する
   * - 全て以外は渡された利用者グループで項目を作成する
   *   - ユーザーの権限を見て、閲覧できない権限の利用者グループは選択肢にしない
   *   - 利用者が一人もいない利用者グループは選択肢にしない
   */
  public createResidentGroupOptions(residentGroups: Array<ResidentGroupsGetModel>, residents: Array<ResidentGetModel>): Array<{ value: number; label: string }> {
    const options: Array<{ value: number; label: string }> = [];

    options.push({
      value: 0,
      label: `全て`
    });

    const canUseResidentGroupMap: Map<number, number> = new Map<number, number>();
    for (const resident of residents) {
      canUseResidentGroupMap.set(resident.groupId, resident.groupId);
    }
    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (canUseResidentGroupMap.has(group.id) && allowedGroupsMap.has(group.id)) {
        options.push({
          value: group.id,
          label: `${group.name}`
        });
      }
    }

    return options;
  }

  /**
   * ### 利用者取得
   */
  public async getResidents(): Promise<Array<ResidentGetModel>> {
    let response: Array<ResidentGetModel> = [];

    try {
      response = await this.residentsService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.residentsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.residentsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 利用者セレクトボックス用項目を作成する
   *
   * - 渡されたグループIDを持つ利用者のみを項目にする
   * - 渡されたグループIDが0(全て)の場合は全利用者を項目にする
   * - 選択肢の表示項目名は 利用者名（利用者部屋名）
   */
  public createResidentOptions(residents: Array<ResidentGetModel>, groupId: number): Array<{ value: number; label: string; kanaName: string | undefined }> {
    // ソート条件があればソートする
    const _residents = residents.concat().sort((a, b) => {
      switch (this.residentSortCondition) {
        // 部屋名昇順
        case ResidentSortCondition.ROOM_NAME_ASC:
          return a.room.localeCompare(b.room, "ja");
        // 利用者名昇順
        case ResidentSortCondition.NAME_ASC: {
          // ふりがなが両方存在する場合はふりがなで比較
          if (a.kanaName && b.kanaName) {
            return a.kanaName.localeCompare(b.kanaName, "ja");
          }
          // ふりがなが存在する方を優先
          if (a.kanaName && !b.kanaName) return -1;
          if (!a.kanaName && b.kanaName) return 1;

          // ふりがなが無いもの同士は漢字名で比較
          return a.name.localeCompare(b.name, "ja");
        }
        default:
          return 0;
      }
    });

    const options: Array<{ value: number; label: string; kanaName: string | undefined }> = [];
    for (const resident of _residents) {
      if (resident.groupId == groupId || groupId == 0) {
        options.push({
          value: resident.id,
          label: `${resident.name}（${resident.room}）`,
          kanaName: resident.kanaName
        });
      }
    }
    return options;
  }

  /**
   * ### 訪問面会設定取得
   */
  public async getReservationSetting(): Promise<ReservationSettingsGetModel> {
    const response: ReservationSettingsGetModel = await this.reservationSettingsService.get(userStore);
    return response;
  }

  /**
   * ### オンライン面会設定取得
   */
  public async getOnlineReservationSetting(): Promise<OnlineReservationSettingsGetModel> {
    const response: OnlineReservationSettingsGetModel = await this.onlineReservationSettingsService.get(userStore);
    return response;
  }

  /**
   * ### グループIDを取得する
   *
   * - グループIDは設定値によって利用者のものを使用するか、共通(ID=1)を使用するか異なる
   * - 更に訪問面会かオンライン面会かでグループIDの持ち方が異なる
   * - 訪問面会の場合
   *   - 自由入力かスケジュール入力かでgroupIdの持ち方が異なる
   *   - 自由入力の場合、グループIDは常に共通のものを使用する
   *   - スケジュール入力の場合、グループ毎に管理するか否かでグループIDが異なる
   *     - グループ毎に管理する場合、利用者のグループIDを使用する
   *     - グループ毎に管理しない場合、グループIDは常に共通のものを使用する
   * - オンライン面会の場合
   *   - グループ毎に管理するか否かでグループIDが異なる
   *   - グループ毎に管理する場合、利用者のグループIDを使用する
   *   - グループ毎に管理しない場合、グループIDは常に共通のものを使用する
   */
  public getGroupId(resident: ResidentGetModel): number {
    // 面会種別が訪問面会
    if (this.type == 0) {
      // 訪問面会設定の入力方法が自由入力
      if (this.setting.reservationInputType == ReservationInputType.FREE) {
        return 1;
      }
      // 訪問面会設定の入力方法がスケジュール入力 かつ グループ毎の入力するかがグループ毎
      else if (this.setting && this.setting.reservationInputType == ReservationInputType.SCHEDULE && this.setting.groupUseType == GroupUseType.USE) {
        return resident.groupId ? resident.groupId : 1;
      }
      // その他
      else {
        return 1;
      }
    }
    // 面会種別がオンライン面会
    else if (this.type == 1) {
      // グループ毎の入力するかがグループ毎
      if (this.onlineSetting && this.onlineSetting.groupUseType == GroupUseType.USE) {
        return resident.groupId ? resident.groupId : 0;
      }
      // その他
      else {
        return 1;
      }
    }
    // その他
    else {
      return 1;
    }
  }

  /**
   * ### 利用者取得
   */
  public async getResident(residentId: number): Promise<ResidentGetModel> {
    const response: ResidentGetModel = await this.residentsService.get(userStore, residentId);
    return response;
  }

  /**
   * ### 利用者にひもづく家族を取得する
   */
  public async getFamilies(residentId: number): Promise<Array<FamilyGetModel>> {
    const response: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);

    return response;
  }

  /**
   * ### 家族セレクトボックス用項目を作成する
   *
   * - 選択肢の表示項目名は 家族ユーザー名（続柄・役割）（メール）
   */
  public createFamilyOptions(families: Array<FamilyGetModel>): Array<{ value: number; label: string }> {
    let familyOptions: Array<{ value: number; label: string }> = [];

    for (const family of families) {
      let label: string = `${family.familyName}`;

      // 続柄・役割を付与する
      if (family.familyRelation && family.familyPosition) {
        label += `（${family.familyRelation}・${family.familyPosition}）`;
      }
      // 続柄のみ
      else if (family.familyRelation) {
        label += `（${family.familyRelation}）`;
      }
      // 役割のみ
      else if (family.familyPosition) {
        label += `（${family.familyPosition}）`;
      }

      // メールユーザーの場合、メールユーザーであることを付与する
      if (family.senderType == SenderType.MAIL) {
        label += "（メール）";
      }

      familyOptions.push({
        value: family.familyId,
        label: label
      });
    }

    return familyOptions;
  }

  /**
   * ### 面会日時のセレクトボックスの年の選択肢を作成する
   *
   * - 予約対象の年は1年後までとする
   */
  public createYears(): Array<{ label: string; value: number }> {
    const years: Array<{ label: string; value: number }> = [];
    for (let i = 0; i < 2; i++) {
      const date: Date = new Date();
      date.setFullYear(date.getFullYear() + i);
      const intlOptions: Intl.DateTimeFormatOptions = { year: "numeric" };
      const jpYear: string = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", intlOptions).format(date).slice(0, -1); // 年が重複するので最終文字だけ削除;
      years.push({ label: `${date.getFullYear()}（${jpYear}）`, value: date.getFullYear() });
    }
    return years;
  }

  /**
   * ### 面会日時のセレクトボックスの月の選択肢を作成する
   *
   * - 過去の月は表示しないので、選択肢には入れない
   */
  public createMonths(year: number): Array<string> {
    const date: Date = new Date();
    const currentYear: number = date.getFullYear();
    const currentMonth: number = date.getMonth();
    const months: Array<string> = [];

    for (let i = 0; i < 12; i++) {
      if (currentYear == year && currentMonth <= i) {
        months.push(String(i + 1));
      } else if (currentYear < year) {
        months.push(String(i + 1));
      }
    }

    return months;
  }

  /**
   * ### 面会日時のセレクトボックスの日の選択肢を作成する
   *
   * - 面会種別に応じてセレクトボックスの選択肢は異なる
   * - 訪問面会の場合
   *   - 訪問面会設定の入力方法が自由入力かスケジュール入力かで選択肢は異なる
   *   - 自由入力の場合は年月から月の最終日を計算して選択肢にする
   *   - スケジュール入力の場合は訪問面会スケジュールを取得して予約可能な日だけを選択肢にする
   * - オンライン面会の場合
   *   - オンライン面会スケジュールを取得して予約可能な日だけを選択肢にする
   */
  public async createDays(groupId: number, year: number, month: number): Promise<Array<string>> {
    let days: Array<string> = [];

    // 面会種別が訪問面会 かつ 訪問面会設定の入力方法が自由入力
    if (this.type == 0 && this.setting.reservationInputType == ReservationInputType.FREE) {
      /**
       * 本メソッドはasyncメソッドなので、Promiseを返すかawaitして非同期処理を実行しないとvueの動作が不定になる
       * issue#1564ではスクロールバーが非表示になる問題が発生した
       * 解決策として、Promise()をnewしてその中で処理を実施して結果をrejectする
       */
      return new Promise((reject: Function) => {
        let days: Array<string> = [];

        // 過去の日は指定できないようにする必要があるので、年月が現在年月と同じであれば制限が必要になる
        const date: Date = new Date();
        const currentYear: number = date.getFullYear();
        const currentMonth: number = date.getMonth() + 1;
        let isCurrentYearMonth: boolean = false;
        if (year == currentYear && month == currentMonth) {
          isCurrentYearMonth = true;
        }

        // 制限が必要な場合は開始日を計算で求める
        const startDay: number = isCurrentYearMonth ? date.getDate() : 1;

        // 年月を指定して日を0でDateを作ると最終日が取得できるので、最終日分セレクトボックスの選択肢を作成する
        const dayCount: number = new Date(year, month, 0).getDate();
        for (let i = startDay; i <= dayCount; i++) {
          days.push(String(i));
        }

        reject(days);
      });
    }
    // 面会種別が訪問面会 かつ 訪問面会設定の入力方法がスケジュール入力
    else if (this.type == 0 && this.setting.reservationInputType == ReservationInputType.SCHEDULE) {
      this.reservationSchedules = await this.getReservableSchedulesService(groupId, this.residentId, String(year), String(month));
      let currentDay: number = 0;
      for (const reservationSchedule of this.reservationSchedules) {
        if (reservationSchedule.date != currentDay && reservationSchedule.canReservation) {
          days.push(String(reservationSchedule.date));
          currentDay = reservationSchedule.date;
        }
      }
    }
    // 面会種別がオンライン面会
    else if (this.type == 1) {
      this.onlineReservationSchedules = await this.getReservableOnlineSchedulesService(groupId, this.residentId, String(year), String(month));
      let currentDay: number = 0;
      for (const reservationSchedule of this.onlineReservationSchedules) {
        if (reservationSchedule.date != currentDay && reservationSchedule.canReservation) {
          days.push(String(reservationSchedule.date));
          currentDay = reservationSchedule.date;
        }
      }
    }

    return days;
  }

  /**
   * ### 訪問予約スケジュールを取得する
   */
  public async getReservableSchedulesService(groupId: number, residentId: number, year: string, month: string): Promise<Array<ReservableSchedulesGetModel>> {
    if (month.length == 1) {
      month = "0" + month;
    }
    const reservationSchedules: Array<ReservableSchedulesGetModel> = await this.reservableSchedulesService.get(userStore, groupId, residentId, year, month);
    return reservationSchedules;
  }

  /**
   * ### 訪問予約スケジュールを取得する
   */
  public async getReservableOnlineSchedulesService(groupId: number, residentId: number, year: string, month: string): Promise<Array<ReservableOnlineSchedulesGetModel>> {
    if (month.length == 1) {
      month = "0" + month;
    }
    const onlineReservationSchedules: Array<ReservableOnlineSchedulesGetModel> = await this.reservableOnlineSchedulesService.get(userStore, groupId, residentId, year, month);
    return onlineReservationSchedules;
  }

  /**
   * ### 面会日時のセレクトボックスの時の選択肢を作成する
   *
   * - 面会種別に応じてセレクトボックスの選択肢は異なる
   * - 訪問面会の場合
   *   - 訪問面会設定の入力方法が自由入力かスケジュール入力かで選択肢は異なる
   *   - 自由入力の場合は24時間分(0～23)を選択肢にする
   *   - スケジュール入力の場合は訪問面会スケジュールを取得して予約可能な時だけを選択肢にする
   * - オンライン面会の場合
   *   - オンライン面会スケジュールを取得して予約可能な時だけを選択肢にする
   */
  public createHours(day: number): Array<string> {
    let hours: Array<string> = [];

    // 面会種別が訪問面会 かつ 訪問面会設定の入力方法が自由入力
    if (this.type == 0 && this.setting.reservationInputType == ReservationInputType.FREE) {
      for (let i = 0; i < 24; i++) {
        hours.push(String(i));
      }
    }
    // 面会種別が訪問面会 かつ 訪問面会設定の入力方法がスケジュール入力
    else if (this.type == 0 && this.setting.reservationInputType == ReservationInputType.SCHEDULE) {
      // 予約可能な時を作成する
      let currentHour: number = -1;
      for (const reservationSchedule of this.reservationSchedules) {
        if (reservationSchedule.date == day && reservationSchedule.hour != currentHour && reservationSchedule.canReservation) {
          hours.push(String(reservationSchedule.hour));
          currentHour = reservationSchedule.hour;
        }
      }
    }
    // 面会種別がオンライン面会
    else if (this.type == 1) {
      // 予約可能な時を作成する
      let currentHour: number = -1;
      for (const reservationSchedule of this.onlineReservationSchedules) {
        if (reservationSchedule.date == day && reservationSchedule.hour != currentHour && reservationSchedule.canReservation) {
          hours.push(String(reservationSchedule.hour));
          currentHour = reservationSchedule.hour;
        }
      }
    }

    return hours;
  }

  /**
   * ### 面会日時のセレクトボックスの分の選択肢を作成する
   *
   * - 面会種別に応じてセレクトボックスの選択肢は異なる
   * - 訪問面会の場合
   *   - 訪問面会設定の入力方法が自由入力かスケジュール入力かで選択肢は異なる
   *   - 自由入力の場合は訪問面会設定の時間単位をもとに分の選択肢を計算で求めて選択肢にする
   *   - スケジュール入力の場合は訪問面会スケジュールを取得して予約可能な分だけを選択肢にする
   *   - 更に訪問面会設定の時間単位をもとに表示対象になるものだけ選択肢にする
   * - オンライン面会の場合
   *   - オンライン面会スケジュールを取得して予約可能な分だけを選択肢にする
   *   - オンライン面会面会設定の時間単位をもとに表示対象になるものだけ選択肢にする
   */
  public createMins(day: number, hour: number): Array<string> {
    let mins: Array<string> = [];

    // 面会種別が訪問面会 かつ 訪問面会設定の入力方法が自由入力
    if (this.type == 0 && this.setting.reservationInputType == ReservationInputType.FREE) {
      const unitCount: number = 60 / this.setting.unit;
      for (let i = 0; i < unitCount; i++) {
        const min: number = i * (60 / unitCount);
        mins.push(String(min));
      }
    }
    // 面会種別が訪問面会 かつ 訪問面会設定の入力方法がスケジュール入力
    else if (this.type == 0 && this.setting.reservationInputType == ReservationInputType.SCHEDULE) {
      // 予約可能な分を作成する
      let currentMin: number = -1;
      for (const reservationSchedule of this.reservationSchedules) {
        if (reservationSchedule.date == day && reservationSchedule.hour == hour && reservationSchedule.min != currentMin && reservationSchedule.canReservation) {
          mins.push(String(reservationSchedule.min));
          currentMin = reservationSchedule.min;
        }
      }
    }
    // 面会種別がオンライン面会
    else if (this.type == 1) {
      // 予約可能な分を作成する
      let currentMin: number = -1;
      for (const reservationSchedule of this.onlineReservationSchedules) {
        if (reservationSchedule.date == day && reservationSchedule.hour == hour && reservationSchedule.min != currentMin && reservationSchedule.canReservation) {
          mins.push(String(reservationSchedule.min));
          currentMin = reservationSchedule.min;
        }
      }
    }

    return mins;
  }

  public changeResidentSearchWord(): void {
    const filterdOptions: Array<{ value: number; label: string; kanaName: string | undefined }> = this.sourceResidentOptions.concat().filter((option) => {
      if (!this.residentSearchWord) {
        return true;
      }

      const existWordFromLabel = 0 <= option.label.indexOf(this.residentSearchWord) ? true : false;
      const existWordFromKanaName = option.kanaName && 0 <= option.kanaName.indexOf(this.residentSearchWord) ? true : false;
      const existWord: boolean = existWordFromLabel || existWordFromKanaName;
      if (option.value == this.residentId && !existWord) {
        this.residentId = "";
      }
      return existWord;
    });
    this.residentOptions = filterdOptions;
    return;
  }

  /**
   * ### 登録確認モーダルを表示する
   *
   * - 表示前にバリデーションチェックして、エラーならモーダルは表示しない
   */
  public async showConfirmModal(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.showRegisterModal = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### 面会予約登録
   *
   * - 面会種別に応じて登録情報、登録用サービスを切り替える
   * - 登録成功ダイアログを表示する
   * - スケジュール登録には予約数制限があるので、制限を超えている場合は409を返すので、エラーメッセージを表示してシステムエラーとしない
   */
  public async registerReservation(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    try {
      // 面会種別が訪問面会
      if (this.type == 0) {
        const requestBody: ReservationsPostModel = await this.createReservationRequestBody();
        await this.reservationsService.post(userStore, this.residentId, requestBody);
      }
      // 面会種別がオンライン面会
      else if (this.type == 1) {
        const requestBody: OnlineReservationPostModel = await this.createOnlineReservationRequestBody();
        await this.onlineReservationsService.post(userStore, this.residentId, requestBody);
      }
      // その他の場合、エラーとして扱う
      else {
        throw new SystemError(`error type is invalid. type: ${this.type}`);
      }

      // 登録成功ダイアログを表示する
      this.showRegisterSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "指定した日時は他の方が予約したため予約できません。他の日時を指定してください。";
      } else if (systemError.statusCode == 404) {
        await this.createView();
        this.errorMessage = "選択された家族が存在しません。ご確認のうえ再度入力して下さい。";
      } else if (systemError.statusCode == 400 && 0 < systemError.originalResponse.indexOf("over location.concurrentNumberLimit")) {
        console.log("systemError.originalResponse", systemError.originalResponse);
        this.errorMessage = "面会場所の同時予約可能数を超えるため予約できません。他の日時または他の面会場所を指定してください。";
      } else {
        throw systemError;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 訪問面会予約登録パラメータ作成
   */
  public async createReservationRequestBody(): Promise<ReservationsPostModel> {
    const datetimeMonth: string = this.month.length == 1 ? "0" + this.month : this.month;
    const datetimeDay: string = this.day.length == 1 ? "0" + this.day : this.day;
    const datetimeHour: string = this.hour.length == 1 ? "0" + this.hour : this.hour;
    const datetimeMin: string = this.min.length == 1 ? "0" + this.min : this.min;
    const datetime: string = `${this.year}${datetimeMonth}${datetimeDay}${datetimeHour}${datetimeMin}00000`;

    // 登録種別が「登録済の家族」であれば家族を取得してその情報を使用する
    let familyPosition: string = "";
    let lineId: string = "";
    let mailAddress: string = "";
    if (this.useFamily == true) {
      let family: FamilyGetModel | undefined = await this.getFamily(this.residentId, this.familyId);
      // 登録のタイミングで他端末にて家族が削除されてしまった場合は例外を投げてエラーメッセージを表示する
      if (family == undefined) {
        const systemError: SystemError = new SystemError("");
        systemError.statusCode = 404;
        throw systemError;
      }
      // 家族が存在すれば家族の情報を書き換える
      else {
        this.familyName = family.familyName;
        this.familyTel = family.familyTel;
        this.familyRelation = family.familyRelation;
        familyPosition = family.familyPosition ? family.familyPosition : "";
        lineId = family.familyLineId ? family.familyLineId : "";
        mailAddress = family.familyMailaddress ? family.familyMailaddress : "";
      }
    } else {
      this.familyId = 0;
      familyPosition = "";
      lineId = "";
      mailAddress = "";
    }

    const requestBody: ReservationsPostModel = {
      groupId: this.groupId,
      datetime: Number(datetime),
      residentName: this.residentName,
      residentRoom: this.residentRoom,
      familyId: this.familyId,
      familyName: this.familyName,
      familyTel: this.familyTel,
      familyRelation: this.familyRelation != "" ? this.familyRelation : "未入力",
      familyPosition: familyPosition,
      familyLineId: lineId,
      familyMailaddress: mailAddress,
      text: this.text && this._showText ? this.text : "",
      location: this.location,
      isSharedReservation: this.isSharedReservation,
      consented: true,
      userId: userStore.loginUser.userId,
      userName: userStore.loginUser.name,
      inputType: InputType.FACILITY_APP
    };

    return requestBody;
  }

  /**
   * ### 利用者にひもづく家族を取得する
   */
  public async getFamily(residentId: number, familyId: number): Promise<FamilyGetModel | undefined> {
    const response: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);

    // 施設APIには家族を一意に取得するAPIがないので、自前で探す
    let result: FamilyGetModel | undefined;
    for (const family of response) {
      if (family.familyId == familyId) {
        result = family;
        break;
      }
    }

    return result;
  }

  /**
   * ### オンライン面会予約登録パラメータ作成
   */
  public async createOnlineReservationRequestBody(): Promise<OnlineReservationPostModel> {
    const datetimeMonth: string = this.month.length == 1 ? "0" + this.month : this.month;
    const datetimeDay: string = this.day.length == 1 ? "0" + this.day : this.day;
    const datetimeHour: string = this.hour.length == 1 ? "0" + this.hour : this.hour;
    const datetimeMin: string = this.min.length == 1 ? "0" + this.min : this.min;
    const datetime: string = `${this.year}${datetimeMonth}${datetimeDay}${datetimeHour}${datetimeMin}00000`;

    // 登録種別が「登録済の家族」であれば家族を取得してその情報を使用する
    let familyPosition: string = "";
    let lineId: string = "";
    let mailAddress: string = "";
    if (this.useFamily == true) {
      let family: FamilyGetModel | undefined = await this.getFamily(this.residentId, this.familyId);
      // 登録のタイミングで他端末にて家族が削除されてしまった場合は例外を投げてエラーメッセージを表示する
      if (family == undefined) {
        const systemError: SystemError = new SystemError("");
        systemError.statusCode = 404;
        throw systemError;
      }
      // 家族が存在すれば家族の情報を書き換える
      else {
        this.familyName = family.familyName;
        this.familyId = family.familyId;
        this.familyTel = family.familyTel;
        this.familyRelation = family.familyRelation;
        familyPosition = family.familyPosition ? family.familyPosition : "";
        lineId = family.familyLineId ? family.familyLineId : "";
        mailAddress = family.familyMailaddress ? family.familyMailaddress : "";
      }
    } else {
      this.familyId = 0;
      familyPosition = "";
      lineId = "";
      mailAddress = "";
    }

    const requestBody: OnlineReservationPostModel = {
      groupId: this.groupId,
      datetime: Number(datetime),
      familyId: this.familyId,
      familyName: this.familyName,
      familyTel: this.familyTel,
      familyRelation: this.familyRelation != "" ? this.familyRelation : "未入力",
      familyPosition: familyPosition,
      familyLineId: lineId,
      familyMailaddress: mailAddress,
      text: this.text && this._showText ? this.text : "",
      isSharedReservation: this.isSharedReservation,
      consented: true,
      userId: userStore.loginUser.userId,
      userName: userStore.loginUser.name,
      inputType: InputType.FACILITY_APP
    };

    return requestBody;
  }

  /**
   * ### 面会予約一覧に遷移する
   */
  public gotoReservationList(): void {
    this.$router.push(PcUrl.ReservationList);

    return;
  }
}

enum ResidentSortCondition {
  /** 未選択 */
  NONE = "",
  /** ID昇順 */
  ROOM_NAME_ASC = "roomNameAsc",
  /** 利用者名昇順 */
  NAME_ASC = "nameAsc"
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.reservation-register {
  .note {
    margin: 0 20px 20px 20px;
    .note-title {
      font-size: 18px;
      font-weight: bold;
    }

    .confirm-list {
      margin-bottom: 0 !important;
      padding-inline-start: 20px;
    }
  }

  .search-filter {
    .search-filter-input-group {
      width: 310px;
      min-width: 310px;

      .search-filter-icon {
        background-color: #fff !important;
        .search-icon {
          @include svg-icon("../../../assets/search.svg", $font-base-color, 20px, 20px);
        }
      }
      .search-filter-input {
        border-left: 0;
      }
    }
  }

  .register-btn,
  .cancel-btn {
    width: 120px;
  }

  .box-footer {
    padding: 10px 0 0 0 !important;
  }
}
</style>
